/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'


const StyledBtn = styled('button')`
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 13px;
  padding: 0;
  position: relative;
  top: 50%;
  text-transform: uppercase;
  transform: ${({ notificationType }) =>
    notificationType === 'fixed' ? 'translateY(-50%)' : 'inherit'};
  color: ${({ theme, color }) =>
    color === 'blue' ? theme.tertiary.medium : '#fff'};

  &:not(:last-child) {
    margin-right: 32px;
  }

  &:focus,
  &:hover {
    outline: none;
    text-decoration: underline;
  }
`

const NotificationBtn = ({ action, type, color, children }) => {
  return (
    <StyledBtn
      onClick={action}
      color={color}
      notificationType={type}
      type='button'
    >
      {children}
    </StyledBtn>
  )
}

NotificationBtn.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  action: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default NotificationBtn
